/** Shared regeneration decision gate for Canonical Generation Cards.
 *
 * When a node already has a current result and material inputs changed,
 * Generate must ask overwrite vs generate-as-new — not silently pick one.
 * First generate / no result / pure failed-retry stay direct.
 */

export type RegenerationDecisionKind = 'direct' | 'ask' | 'blocked_busy'

export function resolveRegenerationDecision(args: {
  hasCurrentResult: boolean
  materialInputsChanged: boolean
  isBusy: boolean
  /** Failed attempt retry with unchanged inputs — follow retry contract, no modal. */
  isFailedRetry?: boolean
}): RegenerationDecisionKind {
  if (args.isBusy) return 'blocked_busy'
  if (args.isFailedRetry && !args.materialInputsChanged) return 'direct'
  if (args.hasCurrentResult && args.materialInputsChanged) return 'ask'
  return 'direct'
}
